// Minimal CSV parser (RFC 4180 subset) — no external deps.
// Supports: quoted values with escaped quotes ("say ""hi"""), commas inside quotes, CRLF/LF newlines.
export function parseCSV(text) {
  const rows = [];
  let field = "";
  let row = [];
  let inQuotes = false;
  let i = 0;
  const s = text.replace(/^\uFEFF/, ""); // strip BOM
  while (i < s.length) {
    const c = s[i];
    if (inQuotes) {
      if (c === '"') {
        if (s[i + 1] === '"') { field += '"'; i += 2; continue; }
        inQuotes = false; i++; continue;
      }
      field += c; i++; continue;
    }
    if (c === '"') { inQuotes = true; i++; continue; }
    if (c === ",") { row.push(field); field = ""; i++; continue; }
    if (c === "\r") { i++; continue; }
    if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; i++; continue; }
    field += c; i++;
  }
  if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
  return rows.filter((r) => r.length > 1 || (r.length === 1 && r[0].trim() !== ""));
}

export function csvToObjects(text, expectedHeaders) {
  const rows = parseCSV(text);
  if (rows.length === 0) return { headers: [], rows: [] };
  const rawHeaders = rows[0].map((h) => h.trim().toLowerCase().replace(/\s+/g, "_"));
  const headerMap = {};
  expectedHeaders.forEach((h) => {
    const idx = rawHeaders.indexOf(h);
    if (idx !== -1) headerMap[h] = idx;
  });
  const out = [];
  for (let r = 1; r < rows.length; r++) {
    const row = rows[r];
    if (row.every((c) => c.trim() === "")) continue;
    const obj = {};
    expectedHeaders.forEach((h) => {
      obj[h] = (row[headerMap[h]] ?? "").trim();
    });
    out.push(obj);
  }
  return { headers: rawHeaders, rows: out };
}
